module.exports = __webpack_public_path__ + "static/img/115.034087e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/115.png
// module id = VRIq
// module chunks = 0